module.exports = "/images/milano-5.jpg";